/**
 * Parsed JSON from insurance document OCR (api/v1/ai/ocr) using INSURANCE_OCR_PROMPT.
 * MemberId is always requested by the prompt (empty string if not on the document).
 */
export interface InsuranceOcrResult {
  ChiefComplaint?: string;
  DOS?: string;
  DoctorName?: string;
  InstituteName?: string;
  AppartmentNo?: string;
  PhoneNumber?: string;
  PayerName?: string;
  payerName?: string;
  payerCode?: string;
  PayerCode?: string;
  MemberId?: string;
  memberID?: string;
  GroupNumber?: string;
  PlanName?: string;
}

export const INSURANCE_OCR_PROMPT = `
You are a JSON API. Extract fields from this health insurance ID card or plan document.

REQUIRED keys (always include every key below in the JSON):
- MemberId: REQUIRED. The member ID, subscriber ID, enrollee ID, or policy/member number used for eligibility. Look for labels such as "Member ID", "Subscriber ID", "Subscriber No", "ID #", "Policy #", "Cert #", "Medicaid ID", "Medicare #", or similar. Copy digits/alphanumeric exactly as printed. If no member identifier appears anywhere on the card, use "".

Also include these keys (use "" when not visible):
- PayerName: insurance company or health plan name as printed
- payerCode: payer or plan ID code if printed (often numeric; may be labeled Payer ID, NAIC, etc.)
- GroupNumber: group number if present
- PlanName: plan or product name if present

Example:

{
  "MemberId": "XYZ123456789",
  "PayerName": "Blue Cross Blue Shield",
  "payerCode": "",
  "GroupNumber": "001",
  "PlanName": "PPO Gold"
}

Output rules (STRICT):
- Return ONLY a valid JSON object starting with "{" and ending with "}".
- Always output the MemberId key; never omit it.
- Use only double quotes for JSON strings.
- Do not include markdown, code fences, or any text outside the JSON object.
- The response must be directly parseable with JSON.parse() without modification.
`.trim();
